// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603022204/js/" + chunkId + "." + {"44":"f9293544","225":"a8d803a2","481":"bcdee7ee","486":"e6fb427a","770":"695f8357"}[chunkId] + ".0.6309127990005328.chunk.js";
};